import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from '@angular/forms';
import { RegisterService } from 'src/app/shared/services/register.service';
import { BoobleModalService } from 'booble-modal';
import { UseTermsModal } from 'src/app/shared/modals/use-terms/use-terms-modal.component';
import { PrivacyPolicyModal } from 'src/app/shared/modals/privacy-policy/privacy-policy-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { RegisterSuccessModalComponent } from '../responses/modals/register-success-modal/register-success-modal.component';
import { TenantGeneralService } from 'src/app/core/tenant-general.service';
import { MerchantService } from 'src/app/core/merchant.service';
import { UserService } from 'src/app/shared/services/user.service';
import { firstValueFrom } from 'rxjs';
import { cnpjValidator } from 'src/app/shared/validators/form-validators';

@Component({
  selector: 'app-register-user',
  templateUrl: './register-user.component.html',
  styleUrls: ['./register-user.component.scss'],
})
export class RegisterUserComponent implements OnInit {
  hide = true;

  tenant: string = '';
  personType: string = '';
  merchant: string = '';
  private readonly notifier: NotifierService;
  public loading: boolean;
  registerForm: FormGroup;
  isMobile: boolean;
  tuneTransactionId: any;
  tuneAffiliateId: any;

  get registerFormControl() {
    return this.registerForm.controls;
  }

  get userRegister() {
    const register = this.registerForm.value;
    return register;
  }

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    notifierService: NotifierService,
    public tenantService: TenantGeneralService,

    private readonly registerService: RegisterService,
    private readonly userService: UserService,
    private fb: FormBuilder,
    private merchantService: MerchantService,
    private readonly modalService: BoobleModalService
  ) {
    this.notifier = notifierService;
    this.tenant = this.route.snapshot.data['tenant'];
    this.personType = this.route.snapshot.data['personType'];

    this.registerForm = fb.group({
      firstName: ['', Validators.required],
      phonenumber: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(100),
        ],
      ],
      acceptedterms: [false, Validators.requiredTrue],
      acceptedoffer: [false],
    });

    this.route.paramMap.subscribe((params) => {
      const result = params.get('personType');

      if (result) this.personType = params.get('personType');
    });

    this.route.queryParams.subscribe((params) => {
      this.tuneTransactionId = params['transaction_id'];
      this.tuneAffiliateId = params['affiliate_id'];
      localStorage.setItem('transaction_id', this.tuneTransactionId);
    });
  }

  ngOnInit(): void {
    if (window.innerWidth < 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }

    this.merchant = this.merchantService.getLoginMerchant(this.tenant);

    this.personType == 'pj'
      ? this.registerForm.addControl(
        'cnpj',
        new FormControl('', [Validators.required, cnpjValidator])
      )
      : this.registerForm.addControl(
        'cpf',
        new FormControl('', Validators.required)
      );
  }

  register() {
    if (this.registerForm.valid) {
      this.loading = true;

      this.personType == 'pj'
        ? this.registerService
          .registerForm(this.userRegister, this.tenant, this.tuneAffiliateId || localStorage.getItem('affiliate_id'))
          .subscribe({
            next: (userResult) => {
              this.notifier.notify(
                'success',
                'Cadastro realizado com sucesso!'
              );
              this.loading = false;
              this.isMobile
                ? this.openRegisterSuccessModal()
                : this.router.navigate([
                  `${this.tenant}/register/${this.personType}/success`,
                ]);
              firstValueFrom(this.userService.updateTuneTransaction(this.tuneTransactionId));
            },
            error: (err) => {
              this.loading = false;
            },
          })
        : this.registerService
            .registerFormPF(
              this.userRegister,
              this.tenant,
              this.tuneAffiliateId || localStorage.getItem('affiliate_id')
            )
            .subscribe({
              next: (userResult) => {
                this.notifier.notify(
                  'success',
                  'Cadastro realizado com sucesso!'
                );
                this.loading = false;
                this.isMobile
                  ? this.openRegisterSuccessModal()
                  : this.router.navigate([
                      `${this.tenant}/register/${this.personType}/success`,
                    ]);
              firstValueFrom(this.userService.updateTuneTransaction(this.tuneTransactionId));
              },
              error: (err) => {
                this.loading = false;
              },
            });
    } else {
      this.notifier.notify('error', 'Preencha o formulário corretamente');
    }
  }

  goToLogin() {
    this.router.navigateByUrl(`${this.tenant}/login?m=${this.merchant}`);
  }

  openRegisterSuccessModal() {
    this.modalService.present(RegisterSuccessModalComponent);
  }

  openPrivacyPolicyModal() {
    this.modalService.present(PrivacyPolicyModal);
  }

  openTermsModal() {
    this.modalService.present(UseTermsModal);
  }
}
